import React from 'react';
import { HeroSection } from '../components/sales/HeroSection';
import { ProblemSection } from '../components/sales/ProblemSection';
import { MechanismSection } from '../components/sales/MechanismSection';
import { Protocol333Section } from '../components/sales/Protocol333Section';
import { WhatYouGetSection } from '../components/sales/WhatYouGetSection';
import { TestimonialsSection } from '../components/sales/TestimonialsSection';
import { OfferSection } from '../components/sales/OfferSection';
import { FAQSection } from '../components/sales/FAQSection';
import { FooterSection } from '../components/sales/FooterSection';
export function SalesPage() {
  return <div className="min-h-screen bg-white font-sans text-charcoal selection:bg-sage-200 selection:text-sage-900" data-id="element-267">
      <nav className="absolute top-0 w-full z-50 py-6 px-4 md:px-8" data-id="element-268">
        <div className="container mx-auto flex justify-between items-center" data-id="element-269">
          <div className="text-2xl font-serif font-bold text-charcoal tracking-tight" data-id="element-270">
            Vientre<span className="text-sage-600" data-id="element-271">Plano</span>21D
          </div>
          <button onClick={() => document.getElementById('offer')?.scrollIntoView({
          behavior: 'smooth'
        })} className="hidden md:block px-6 py-2 bg-white/80 backdrop-blur-sm border border-sage-200 text-sage-700 font-bold rounded-full hover:bg-white transition-colors text-sm" data-id="element-272">
            Acceso Miembros
          </button>
        </div>
      </nav>

      <main data-id="element-273">
        <HeroSection data-id="element-274" />
        <ProblemSection data-id="element-275" />
        <MechanismSection data-id="element-276" />
        <Protocol333Section data-id="element-277" />
        <WhatYouGetSection data-id="element-278" />
        <TestimonialsSection data-id="element-279" />
        <OfferSection data-id="element-280" />
        <FAQSection data-id="element-281" />
      </main>

      <FooterSection data-id="element-282" />
    </div>;
}